import { AfterViewInit, Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { CommonService } from 'src/app/services/common.service';
import getBlobDuration from 'get-blob-duration'
@Component({
  selector: 'app-audio-component',
  templateUrl: './audio-component.component.html',
  styleUrls: ['./audio-component.component.scss']
})
export class AudioComponentComponent implements OnInit, AfterViewInit {
  @Input() src: any;
  // @Input() currentTime:any
  // @Input() name:any

  id = 'id'
  constructor(public commonService: CommonService) { }
  audioPlayer: any
  audio!: HTMLAudioElement;
  timeline: any
  volumeSlider: any
  ngOnInit(): void {
    this.id = 'id' + Math.random().toString(16).slice(2)
    this.src = this.commonService.get_storage_cdn_url(this.src);
  }

  ngAfterViewInit(): void {

    this.audio = new Audio(this.commonService.get_storage_cdn_url(this.src));
    let audioElement = "#" + this.id + " .audio-player"
    this.audioPlayer = document.querySelector(audioElement);

    this.initialize()
  }
  ngOnChanges(changes: SimpleChanges) {
    if (this.audio != undefined) {
      this.audio.src = this.commonService.get_storage_cdn_url(this.src);
      const playBtn = this.audioPlayer.querySelector(" .controls .toggle-play");
      playBtn.classList.remove("pause");
      playBtn.classList.add("play");
      this.audio.pause();
      this.initialize();
    }
  }
  ngOnDestroy() {
    this.audio.pause();
    this.audio.remove()
  }
  initialize() {
    this.audio.addEventListener(
      "loadeddata",
      () => {
        this.audioPlayer.querySelector(" .time .length").textContent = this.getTimeCodeFromNum(
          this.audio.duration
        );
        // this.commonService.fileData.duration = this.commonService.formatTime( this.audio.duration )
        this.audio.volume = .75;
      },
      false
    );
    //click on timeline to skip around
    this.timeline = this.audioPlayer.querySelector(".timeline");
    this.timeline.addEventListener("click", (e: any) => {
      const timelineWidth = window.getComputedStyle(this.timeline).width;
      const timeToSeek = e.offsetX / parseInt(timelineWidth) * this.audio.duration;
      this.audio.currentTime = timeToSeek;
    }, false);


    //toggle between playing and pausing on button click
    const playBtn = this.audioPlayer.querySelector(" .controls .toggle-play");
    playBtn.addEventListener(
      "click",
      () => {
        if (this.audio.paused) {
          playBtn.classList.remove("play");
          playBtn.classList.add("pause");
          this.audio.play();
        } else {
          playBtn.classList.remove("pause");
          playBtn.classList.add("play");
          this.audio.pause();
        }
      },
      false
    );

    //check audio percentage and update time accordingly
    setInterval(() => {
      const progressBar = this.audioPlayer.querySelector(" .progress");
      progressBar.style.width = this.audio.currentTime / this.audio.duration * 100 + "%";
      this.audioPlayer.querySelector(" .time .current").textContent = this.getTimeCodeFromNum(
        this.audio.currentTime
      );
      if (progressBar.style.width == '100%') {
        playBtn.classList.remove("pause");
        playBtn.classList.add("play");
        this.audio.pause();
      }
    }, 500);

  }


  getTimeCodeFromNum(num: any) {
    if (num == Infinity || num == undefined) {
      num = this.commonService.RecordedAudioDuration;
      this.commonService.RecordedAudioDuration = 0;
    }
    let seconds = parseInt(num);
    let minutes = parseInt('' + seconds / 60);
    seconds -= minutes * 60;
    const hours = parseInt('' + minutes / 60);
    minutes -= hours * 60;

    if (hours === 0) return `${minutes}:${String(seconds % 60).padStart(2, '' + 0)}`;
    return `${String(hours).padStart(2, '' + 0)}:${minutes}:${String(
      seconds % 60
    ).padStart(2, '' + 0)}`;
  }

}
